import _ from 'underscore';
import ko from 'knockout';
import { Validation } from '@bingads-webui/validation';
import * as putil from '@bingads-webui-universal/primitive-utilities';

const { getLength } = Validation.string;

/**
 * Add aggregate length constraint to Observable
 * @param {Observable} ret - Object to add custom constraints
 * @param {Object} constraint - Aggregate length constraint
 * @returns {undefined} - extend ret with custom constraints
 */
function aggregateLength(ret, constraint) {
  const { properties, maxLength } = constraint;
  const strProperties = properties.toString();

  if (_.isUndefined(ret[strProperties])) {
    _.extend(ret, _.object([strProperties], [{}]));
  }

  _.extend(ret[strProperties], {
    remaining: ko.computed(() => {
      const sum = putil.sumBy(properties, property =>
        getLength(ret[property](), constraint.distinguishCJK));

      return maxLength - sum;
    }),
  });

  _.extend(ret[strProperties], {
    validate: ko.computed(() => ret[strProperties].remaining() >= 0),
  });

  _.each(properties, (property) => {
    _.extend(ret[property], {
      maxLength: ko.computed(() => ret[strProperties].remaining() +
        getLength(ret[property](), constraint.distinguishCJK)),
      validate: _.isFunction(ret[property].validate) ?
        _.compose(isValid => isValid && ret[strProperties].validate(), ret[property].validate) :
        ret[strProperties].validate,
    });
  });
}

const constraintsHandlers = {
  aggregateLength,
};

/**
 * Generate custom constraints which not defined in json schema
 * @param {Observable} ret - Object to add custom constraints
 * @param {JsonSchema} schema - Object define constraints
 * @returns {Observable} - return the Observable passed in, has add validate to correspond property
 */
export function CustomConstraints(ret, schema) {
  if (_.isArray(schema.constraints)) {
    _.each(schema.constraints, (constraint) => {
      constraintsHandlers[constraint.type](ret, constraint);
    });
  }

  return ret;
}
